import isFuture from 'date-fns/isFuture';
import parseISO from 'date-fns/parseISO';

import LinearProgress from '@classify/react-core-components/LinearProgress';
import { Illustration, ListItem } from '../../../ui';
import defaultTranslations from '../../constants/defaultTranslations';
import { filterPartners } from '../../services/partners';

import CreatorPartners from '../CreatorPartners';
import ReleaseDate from '../ReleaseDate';

/**
 * @deprecated
 * ### Description
 * `LearningContentListItem` has been deprecated and replaced by Classify `CourseItem`.
 *
 * ### Example
 * ```
 * import CourseItem from '@classify/react-product-components/CourseItem';
 * ```
 */
export default function LearningContentListItem({
  category = '',
  categoryColor,
  classes = {},
  illustration = '',
  illustrationComponent: IllustrationComponent = Illustration,
  metadata = [],
  openedAt = null,
  progress = null,
  releaseSeason = '',
  releaseYear = 0,
  partners = [],
  title,
  locale = 'en',

  translations = {
    partners: 'Partners',
    progressBarAriaLabel: '0% achieved',
    ...defaultTranslations,
  },

  ...otherProps
}) {
  const filteredPartners = filterPartners(partners);

  let metadataToDisplay = metadata;

  if (filteredPartners.length) {
    metadataToDisplay = metadata.concat(
      <CreatorPartners
        key="partners"
        partners={partners}
        translations={{ accessibilityLabel: translations.partners }}
      />
    );
  }

  // eslint-disable-next-line react/no-array-index-key
  metadataToDisplay = metadataToDisplay.map((data, index) => <span key={index}>{data}</span>);

  const isActive = !!openedAt;
  const openingInFuture = isFuture(parseISO(openedAt));

  const { releaseDate, illustration: illustrationClassName, ...itemClasses } = classes;

  const itemIllustration = (
    <>
      <ReleaseDate
        classes={{
          text: releaseDate,
        }}
        openedAt={openedAt}
        releaseSeason={releaseSeason}
        releaseYear={releaseYear}
        locale={locale}
        translations={translations}
      />
      {typeof illustration === 'string' ? (
        <IllustrationComponent
          src={isActive && !openingInFuture ? illustration : null}
          classes={{ illustration: illustrationClassName }}
        />
      ) : (
        illustration
      )}
      {progress !== null && (
        <LinearProgress
          value={progress}
          maxValue={100}
          shape="rounded"
          aria-label={translations.progressBarAriaLabel}
        />
      )}
    </>
  );

  return (
    <ListItem
      classes={itemClasses}
      illustration={itemIllustration}
      overlineLabel={category}
      overlineLabelColor={isActive ? categoryColor : null}
      shouldHandleHover={isActive}
      sublineLabel={metadataToDisplay}
      title={title}
      {...otherProps}
    />
  );
}
